import apiClient from './client';

export interface Program {
  id: number;
  kode: string;
  nama: string;
  deskripsi?: string;
  tanggalMulai?: string;
  tanggalSelesai?: string | null;
  jenisProgram: 'utama' | 'khusus';
  kategoriProgram?: string | null;
  status: string;
  targetDonasi?: number;
  cover?: string | null;
  createdAt?: string;
}

export interface ProgramListParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  jenisProgram?: 'utama' | 'khusus';
}

export interface ProgramListResponse {
  data: Program[];
  total: number;
  page: number;
  limit: number;
}

export interface MessageResponse {
  message: string;
}

export interface UploadImageResponse {
  message: string;
  url: string;
}

export const programApi = {
  getAll: async (params: ProgramListParams = {}): Promise<ProgramListResponse> => {
    const response = await apiClient.get('/api/program', { params });
    return response.data;
  },

  getById: async (id: number): Promise<Program> => {
    const response = await apiClient.get(`/api/program/${id}`);
    return response.data;
  },

  create: async (data: Partial<Program>): Promise<MessageResponse> => {
    const response = await apiClient.post('/api/program', data);
    return response.data;
  },

  update: async (id: number, data: Partial<Program>): Promise<MessageResponse> => {
    const response = await apiClient.put(`/api/program/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<MessageResponse> => {
    const response = await apiClient.delete(`/api/program/${id}`);
    return response.data;
  },

  toggleStatus: async (id: number): Promise<MessageResponse> => {
    const response = await apiClient.patch(`/api/program/${id}/toggle-status`);
    return response.data;
  },

  uploadCover: async (file: File): Promise<UploadImageResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post('/api/program/upload-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};
